export const ENVIRONMENTS: { [index: string]: string } = {
  localhost: 'dev',
  development: 'dev',
  qa: 'qa',
  testenv: 'qa',
  internal: 'piloto',
  production: 'prod',
};
